module.exports = __webpack_public_path__ + "img/image5.e3f484e9.jpg";